import React, {useState} from 'react';
import SVGIcons from '@components/SVGIcon';
import {LeadGenerationForm} from './LeadGenerationForm';
import {Modal} from '@components/Modal';
import {SuccessPopup} from '@damascus-components/SuccessPopup';
import {createDownloadLink} from '@utils/createDownloadLink';
import {getFileData} from '@services/Download/getFileData';
import {
  trackFileDownload,
  trackMouseClicks,
} from '@utils/googleAnalytics/googleAnalyticsEvents';
import {datadogLogs} from '@datadog/browser-logs';

import cn from './ViewBrochureButton.module.scss';

export const isValidUrl = (url: string): boolean => {
  const regex = /^(https):\/\/[^\s$.?#].[^\s]*$/;
  return regex.test(url);
};

export interface ViewBrochureButtonProps {
  link: string;
  id: string | number;
  communityName: string;
  lsqListing: boolean;
}

export const ViewBrochureButton = (props: ViewBrochureButtonProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);
  const [isCallback, setIsCallback] = useState(false);

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setModalOpen(true);
    trackMouseClicks({type: 'button', label: 'view_brochure'});
  };

  const onClose = () => {
    setModalOpen(false);
  };

  const isValidUrl = (url: string): boolean => {
    const regex = /^(https):\/\/[^\s$.?#].[^\s]*$/;
    return regex.test(url);
  };

  const callback = async (type: string) => {
    if (props.link && isValidUrl(props.link)) {
      let link: HTMLAnchorElement | null = null;
      if (type === 'view') {
        link = document.createElement('a');
        link.href = props.link;
        link.setAttribute('target', '_blank');
      } else {
        try {
          const fileData = await getFileData(props.link).getResponse();
          link = createDownloadLink(
            fileData as Blob,
            'Brochure'
          ) as HTMLAnchorElement;
          trackFileDownload('success', {fileUrl: props.link});
        } catch (error) {
          datadogLogs.logger.error('Error fetching file data:', {error});
          trackFileDownload('fail', {fileUrl: props.link});
          return;
        }
      }
      if (link) {
        await document.body.appendChild(link);
        await link.click();
        document.body.removeChild(link);
      }
    }
  };

  const handleOkSuccess = () => {
    setSuccess(false);
  };

  const handleSubmit = (isCallback: boolean) => {
    toggleLeadGenForm();
    setSuccess(true);
    setIsCallback(isCallback);
  };

  const toggleLeadGenForm = () => setModalOpen((prev) => !prev);

  const message = `We're thrilled that you've chosen to download/view our ${props.communityName} brochure and express
   your interest in Aldar Properties.The brochure will be downloaded/open in a few seconds. `;

  if (!(props.link && isValidUrl(props.link))) return;

  return (
    <div className={cn.btn}>
      <SuccessPopup
        isOpen={success}
        onOk={handleOkSuccess}
        customMessage={message}
      />
      <Modal isOpen={modalOpen} onClose={onClose} title={'View Brochure'} close>
        <div className={cn.formContent}>
          <LeadGenerationForm
            type='community'
            leadGenerationId={props.id}
            onClose={handleSubmit}
            onBrochureAction={callback}
            lsqListing={props.lsqListing}
          />
        </div>
      </Modal>
      <li
        data-testid='view-brochure'
        className={cn.btn__brochure}
        onClick={onClick}>
        <SVGIcons type='pdf-icon-svg' />
        <span>View Brochure</span>
      </li>
    </div>
  );
};
